import styled from 'styled-components'

export const Content = styled.div`
  display: inline-flex;
  align-items: flex-end;
  column-gap: 4px;
`

export const Measuring = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 32px;
  color: ${props => props.theme.colors.color2d3139};
`

export const Unit = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 10px;
  color: ${props => props.theme.colors.color545e6c};
`
